import React, { MouseEvent, useState } from 'react'
import styled from 'styled-components'
import ContextMenuIcon from '../../images/ContextMenuIcon.png'
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap'

const StyledMenu = styled(DropdownMenu)`
  font-size: ${({ theme }) => theme.fontSize.s12};

  color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
  margin: 0;
  padding: 0;
  background-color: ${({ theme }) => theme.colors.gray1};
  border: 1px solid #9093a1;
  border-radius: 0 0 3px 3px;

  transition: opacity 0.15s linear;
`

const StyledDropdownItem = styled(DropdownItem)`
  color: ${({ theme }) => theme.colors.white};
  background: transparent;
  padding: 10px;

  :hover {
    color: ${({ theme }) => theme.colors.white};
    background: ${({ theme }) => theme.colors.gray4};
  }
`

const StyledDropdownToggle = styled(DropdownToggle)`
  padding: 0;
  width: 30px;
  height: 30px;
  transition: 0.3s;
  :hover {
    background: ${({ theme }) => theme.colors.gray6};
  }
  border-radius: 50%;
`

type Props = {
  id: number
  actions: string[]
  onAction: (action: string, rowId: number) => void
}

const ContextMenu: React.FC<Props> = (props) => {
  const [isOpen, setIsOpen] = useState(false)
  const { id, actions, onAction } = props

  const toggleDropdown = () => setIsOpen(!isOpen)

  const handleActionClick = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault()
    onAction((e.target as HTMLInputElement).value, id)
  }

  const actionsList = actions.map((item, key) => (
    <StyledDropdownItem onClick={handleActionClick} key={key} value={item}>
      {item}
    </StyledDropdownItem>
  ))

  return (
    <Dropdown
      key={id}
      direction="left"
      isOpen={isOpen}
      toggle={toggleDropdown}
    >
      <StyledDropdownToggle
        tag="button"
        data-toggle="dropdown"
        aria-expanded={isOpen}
      >
        <img src={ContextMenuIcon} alt="contextMenu" />
      </StyledDropdownToggle>
      <StyledMenu>{actionsList}</StyledMenu>
    </Dropdown>
  )
}

export default ContextMenu
